import config from "../config/config";

export const JailWhiteListPath = [
  "/injail",
  "/jail",
  "/vault",
  "/buy",
  "/crate",
  "/rank",
  config.gitbookUrl,
];
export const BribePerMin = 1500;

export const CrimeFailedReason = [
  "Basic Crime failed",
  "Basic Crime failed",
  "Basic Crime failed",
  "Basic Crime failed",
  "Booze buy failed",
  "Booze sell failed",
  "Narcotics buy failed",
  "Narcotics sell failed",
  "Bust out failed",
  "Nick car failed",
];
